module.exports = __webpack_public_path__ + "static/img/logo@2x.ab870d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/header/logo@2x.png
// module id = Z2Ax
// module chunks = 1